import { render, staticRenderFns } from "./ListarGerenciamentoServico.vue?vue&type=template&id=424a67bc"
import script from "./ListarGerenciamentoServico.vue?vue&type=script&lang=js"
export * from "./ListarGerenciamentoServico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports